import {inject, Injectable, signal} from '@angular/core';
import {AppNotification} from './notification.model';
import {ToastMessageEffectService} from '../../../core/services/toast-message-effect.service';

@Injectable({ providedIn: 'root' })
export class NotificationsStore {
	private toastEffect = inject(ToastMessageEffectService);

	private readonly _notifications = signal<AppNotification[]>([]);
	private readonly _loading = signal(false);
	private readonly _error = signal<string | null>(null);
	private readonly _lastNotification = signal<AppNotification | null>(null);

	readonly notifications = this._notifications.asReadonly();
	readonly loading = this._loading.asReadonly();
	readonly error = this._error.asReadonly();
	readonly lastNotification = this._lastNotification.asReadonly();

	constructor() {
		this.toastEffect.registerErrorSignal(this.error);
	}

	setNotifications(notifications: AppNotification[]) {
		this._notifications.set(notifications);
	}

	addNotification(notification: AppNotification) {
		this._notifications.update(list => [notification, ...list])
		this._lastNotification.set(notification)
	}

	updateNotification(patch: Partial<AppNotification> & { id: string }) {
		this._notifications.update(list =>
			list.map(n =>
				n.id === patch.id
					? { ...n, ...patch }
					: n
			)
		);
	}

	markAllAsRead() {
		this._notifications.update(list =>
			list.map(n => n.read ? n : { ...n, read: true })
		);
	}

	setLoading(val: boolean) {
		this._loading.set(val);
	}

	setError(err: string | null) {
		this._error.set(err);
	}
}
